import axios from "axios";

const baseURL = `${process.env.REACT_APP_BACKEND_URL}/gsb-ndrs-webapp`;

const createAxiosInstance = (baseUrl) => {
  return axios.create({
    baseURL: baseUrl, // Replace with your API's base URL
    timeout: 60000, // Set a timeout limit
    headers: {
      "Content-Type": "application/json",
      // Add any custom headers here
    },
  });
};

export const apiAxiosInstance = createAxiosInstance(baseURL);

export const post = async (url, data, config, axiosInstance, token) => {
  try {
    if (token) {
      axiosInstance.defaults.headers.common["Authorization"] = token;
    }
    const response = await axiosInstance.post(url, data, config);
    return response.data;
  } catch (error) {
    console.debug(error);
    throw error;
  }
};

export const get = async (url, params, config, axiosInstance, token) => {
  try {
    if (token) {
      axiosInstance.defaults.headers.common["Authorization"] = token;
    }
    const response = await axiosInstance.get(url, {
      ...config,
      params,
    });
    return response.data;
  } catch (error) {
    console.debug(error);
    throw error;
  }
};

export const postGeneral = (url, data, token) => {
  const headers = {
    "Content-Type": "application/json",
  };

  if (token) {
    axios.defaults.headers.common["Authorization"] = token;
  }

  return axios.post(url, data, {
    headers: headers,
  });
};

export const getGeneral = (url, params, token) => {
  const headers = {
    "Content-Type": "application/json",
  };

  if (token) {
    axios.defaults.headers.common["Authorization"] = token;
  }

  return axios.get(url, params, {
    headers: headers,
  });
};

export const getPdf = async (url, params) => {
  return await axios.get(url, params, { responseType: "blob" });
};
